import { useRouteError } from "react-router-dom";


function ErrorBoundary() {
    let error = useRouteError();
    return <div>Dang!</div>;
  }

  export default ErrorBoundary